import React, { useState } from "react";
import {
  Box,
  Card,
  Typography,
  Button,
  Chip,
  Stack,
  CircularProgress,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  acceptOpportunityCluster,
  fetchOpportunitiesForVendor,
} from "../../../../redux/slices/vendorJobSlice";
import { useNavigate } from "react-router-dom";

export default function OppotunitiesCard() {
  const dispatch = useDispatch();
  const { oppotunities } = useSelector((state) => state.vendorJob);
  const { vendorId } = useSelector((state) => state.vendorAuth);
  const formatPrice = (price) => `₹${price.toLocaleString("en-IN")}`;
  const [loadingClusterId, setLoadingClusterId] = useState(null);
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        borderRadius: 5,
        backgroundColor: "white",
        height: "73vh",
      }}
    >
      {/* Header */}
      <Box
        px={4}
        py={2}
        sx={{
          top: 0,
          backgroundColor: "#F8FAFC",
          borderTopLeftRadius: 8,
          borderTopRightRadius: 8,
          borderBottom: "2px solid #E0E0E0",
          position: "sticky",
          zIndex: 10,
        }}
      >
        <Typography variant="h4" sx={{ fontWeight: 600 }}>
          Opportunities
        </Typography>
        <Typography>{`${oppotunities.length} Cluster`}</Typography>
      </Box>

      {/* Card Grid */}
      <div className=" flex gap-4 h-full ">
        <div className=" p-4 overflow-y-auto flex-1 w-full rounded-2xl my-2 bg-[#F5F5F5] ">
          <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {oppotunities.map((cluster) => (
              <Card
                key={cluster._id}
                sx={{
                  width: "100%",
                  borderRadius: 5,
                  boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.05)",
                  padding: 2,
                  backgroundColor: "white",
                  marginBottom: 2,
                }}
              >
                <Box sx={{ mb: 1 }}>
                  <Stack direction="row" alignItems="center" gap={2}>
                    <Chip
                      label={
                        cluster?.serviceType === "0"
                          ? "Fabrication & Printing"
                          : cluster?.serviceType === "1"
                          ? "Fabrication"
                          : cluster?.serviceType === "2"
                          ? "Printing"
                          : "Unknown"
                      }
                      sx={{
                        bgcolor: "rgba(255, 159, 67, 0.1)",
                        color: "#ff9f43",
                        fontWeight: 600,
                        borderRadius: 5,
                        height: 28,
                      }}
                    />
                    <Chip
                      label={formatPrice(cluster?.paymentAmount)}
                      sx={{
                        bgcolor: "rgba(76, 175, 80, 0.1)",
                        color: "#4caf50",
                        fontWeight: 600,
                        borderRadius: 5,
                        height: 28,
                      }}
                    />
                  </Stack>
                </Box>

                <Typography
                  variant="h6"
                  component="h2"
                  sx={{ fontWeight: 600, mb: 1 }}
                >
                  {cluster?.productType}
                </Typography>

                <Typography
                  variant="body2"
                  color="text.secondary"
                  pb={1}
                  sx={{
                    mb: 1,
                    borderBottom: "2px dashed #E0E0E0",
                  }}
                >
                  <Box
                    component="span"
                    sx={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {new Date(cluster?.jobStartingDate).toLocaleDateString(
                      "en-GB",
                      {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                      }
                    )}{" "}
                    -{" "}
                    {new Date(cluster?.jobCompletionDate).toLocaleDateString(
                      "en-GB",
                      {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                      }
                    )}
                    <Box
                      component="span"
                      sx={{
                        mx: 1,
                        fontWeight: 900,
                        fontSize: "1.5rem",
                      }}
                    >
                      •
                    </Box>
                    {cluster?.totalNumberOfJobs} Nos
                  </Box>
                </Typography>

                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Button
                    variant="text"
                    sx={{
                      color: "text.primary",
                      textDecoration: "underline",
                      p: 0,
                      "&:hover": {
                        backgroundColor: "transparent",
                      },
                      fontWeight: 500,
                      borderRadius: 1,
                    }}
                    onClick={() => navigate("/vendorportal/jobs/cluster")}
                  >
                    View Details
                  </Button>
                  <Button
                    variant="contained"
                    sx={{
                      borderRadius: 2,
                      fontWeight: 500,
                      textTransform: "none",
                      gap: 1,
                    }}
                    disabled={loadingClusterId === cluster._id}
                    onClick={() => {
                      setLoadingClusterId(cluster._id); // Set loading for this cluster
                      dispatch(
                        acceptOpportunityCluster({
                          clusterId: cluster._id,
                          vendorId,
                        })
                      )
                        .unwrap()
                        .then((res) => {
                          dispatch(fetchOpportunitiesForVendor(vendorId)); // Refresh list
                        })
                        .catch((err) => {
                          console.error(err || "Something went wrong");
                        })
                        .finally(() => {
                          setLoadingClusterId(null); // Reset loading
                        });
                    }}
                  >
                    {loadingClusterId === cluster._id ? (
                      <CircularProgress size={20} color="inherit" />
                    ) : (
                      "Accept"
                    )}
                  </Button>
                </Stack>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </Box>
  );
}
